import { Directive, HostListener } from '@angular/core';

import { getCurrentAccessDetailsState } from '@app-shared/reducers';
import { State } from '@app-shared/reducers/user-permission.reducer';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appDisableRightClick]',
})
export class DisableRightClickDirective {
  constructor(private store: Store<State>) {}

  private hasPermissionToDownload: Boolean = true;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  public ngOnInit() {
    this.store
      .select(getCurrentAccessDetailsState)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(({ permissions = [] }) => {
        this.hasPermissionToDownload = permissions.indexOf('media:download') > 0;
      });
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    if (!this.hasPermissionToDownload) event.preventDefault();
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
